/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type PluginPublishStatus = {
  /**
   * Whether the plugin's auto sync is off and it has changes, or has never been published, so only a manual sync publishes it.
   */
  awaitingManualSync: boolean;
  /**
   * The plugin's slug.
   */
  slug: string;
  /**
   * Whether the plugin's published package is current. With auto sync on: an automatic publish would push nothing new for it, its package and the marketplace manifests alike. With auto sync off: its package matches what it was last published with.
   */
  upToDate: boolean;
};

/** @internal */
export const PluginPublishStatus$inboundSchema: z.ZodMiniType<
  PluginPublishStatus,
  unknown
> = z.pipe(
  z.object({
    awaiting_manual_sync: z.boolean(),
    slug: z.string(),
    up_to_date: z.boolean(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "awaiting_manual_sync": "awaitingManualSync",
      "up_to_date": "upToDate",
    });
  }),
);

export function pluginPublishStatusFromJSON(
  jsonString: string,
): SafeParseResult<PluginPublishStatus, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => PluginPublishStatus$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'PluginPublishStatus' from JSON`,
  );
}
